import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Chargement en cours...", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white add-user-card"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-black fw-semibold" }, "Modifier un étudiant")
], -1)
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom de l'étudiant "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_11 = { class: "col-md-4 mb-3" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Prénom de l' étudiant "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_14 = { class: "col-md-4 mb-3" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_17 = { class: "col-md-4 mb-3" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sexe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone 1 ", -1)
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date de naissance "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Pays de naissance "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Catégorie d'étudiant "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Formateur ? ", -1)
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Commune ", -1)
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Quartier ", -1)
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nombre d'années d'expériences ", -1)
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Qualification "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Activité "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_51 = { class: "col-md-4" }
const _hoisted_52 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Langue "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Poste occupé actuellement ", -1)
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Catégorie Profesionnelle ", -1)
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Informations complémentaires ", -1)
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = { class: "row" }
const _hoisted_65 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_66 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "border border-primary mb-1" }
const _hoisted_69 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-white" }, "Pièce(s)")
], -1)
const _hoisted_71 = { class: "col-md-5" }
const _hoisted_72 = { class: "d-flex float-end" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "row gx-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
      /*#__PURE__*/_createTextVNode("Type de pièce "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
      /*#__PURE__*/_createTextVNode("Numéro de pièce "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
      /*#__PURE__*/_createTextVNode("Image "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, "Action")
  ])
], -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1)
const _hoisted_76 = { class: "col-md-4 mb-3" }
const _hoisted_77 = {
  key: 0,
  class: "col-md-4 mb-3"
}
const _hoisted_78 = {
  key: 1,
  class: "col-md-4 mb-3"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Aucun numéro requis pour la photo d'identité", -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "col-md-3 mb-3" }
const _hoisted_82 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Actuel : ", -1)
const _hoisted_84 = ["href"]
const _hoisted_85 = {
  key: 2,
  class: "col-md-1 mb-3"
}
const _hoisted_86 = ["onClick"]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-0 position-relative top-1" }, null, -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "col-md-12 mt-3" }
const _hoisted_90 = { class: "d-flex align-items-center" }
const _hoisted_91 = ["disabled"]
const _hoisted_92 = {
  key: 0,
  class: "fa fa-save me-2"
}
const _hoisted_93 = {
  key: 1,
  class: "fa fa-spinner fa-spin me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "etudiantForm",
            onSubmit: _ctx.editEtudiant,
            "validation-schema": _ctx.etudiantSchema,
            "initial-values": _ctx.initialValues
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_Field, {
                      name: "nom",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le nom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_Field, {
                      name: "prenom",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le prenom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "prenom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_Field, {
                      name: "email",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer l'email"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_Field, {
                      name: "sexe",
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          searchable: true,
                          options: ['Masculin', 'Féminin'],
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le sexe" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "sexe",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_Field, { name: "telephone1" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_vue_tel_input, {
                          value: field.value || '',
                          onInput: ($event: any) => (field.onChange($event)),
                          defaultCountry: "BJ",
                          mode: "international",
                          onValidate: _ctx.validate,
                          class: "shadow-none fs-md-15 text-black py-2",
                          placeholder: "Entrer le numéro de téléphone"
                        }, null, 8, ["value", "onInput", "onValidate"])
                      ]),
                      _: 1
                    }),
                    (!_ctx.validPhone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Veuillez entrer un numéro correct"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone1",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_Field, {
                      name: "dateNaissance",
                      type: "date",
                      max: _ctx.currentDate,
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, null, 8, ["max"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "dateNaissance",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_Field, { name: "nationalite" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.countries,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le pays de naissance" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nationalite",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_Field, { name: "categorieEtudiant" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.categorieEtudiantOptions,
                          "track-by": "value",
                          label: "label",
                          reduce: option => option.value,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la catégorie" }), null, 16, ["options", "reduce", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "categorieEtudiant",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_Field, { name: "categorieFormateur" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.categorieFormateurOptions,
                          "track-by": "value",
                          label: "label",
                          reduce: option => option.value,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la catégorie" }), null, 16, ["options", "reduce", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "categorieFormateur",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_Field, { name: "commune" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Multiselect, {
                          options: _ctx.communeOptions,
                          modelValue: _ctx.selectedCommune,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCommune) = $event)),
                          onChange: _ctx.communeChange,
                          "track-by": "value",
                          label: "label",
                          placeholder: "Sélectionner la commune"
                        }, null, 8, ["options", "modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "commune",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_Field, { name: "quartier" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Multiselect, {
                          options: _ctx.quartierOptions,
                          modelValue: _ctx.selectedQuartier,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedQuartier) = $event)),
                          "track-by": "value",
                          label: "label",
                          placeholder: "Sélectionner le quartier",
                          noOptionsText: "Sélectionner d'abord une commune"
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "quartier",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode(_component_Field, {
                      name: "anneeExperience",
                      type: "number",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le nombre"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "anneeExperience",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_Field, { name: "qualification" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.qualificationOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner la qualification" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "qualification",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode(_component_Field, { name: "activites" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.activiteOptions,
                          searchable: true,
                          mode: "tags",
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner l'activité" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "activites",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_Field, { name: "langues" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.languesOptions,
                          searchable: true,
                          mode: "tags",
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner les langues" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "langues",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createVNode(_component_Field, {
                      name: "poste",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le poste"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "poste",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _createVNode(_component_Field, {
                      name: "categorie",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer la categorie"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "categorie",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_Field, {
                      name: "biographie",
                      rows: "2",
                      as: "textarea",
                      placeholder: "Ajouter d'autres informations",
                      class: "form-control shadow-none rounded-0 text-black"
                    }, {
                      default: _withCtx(({ field }) => [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          class: "form-control shadow-none rounded-0 text-black"
                        }, null, 8, _hoisted_63), [
                          [_vModelText, field.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "biographie",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _hoisted_70,
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                                  type: "button",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRowPiece()))
                                }, [
                                  _hoisted_73,
                                  _createTextVNode(" Ajouter une pièce ")
                                ], 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_74,
                            _hoisted_75,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieces, (piece, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "row gx-1",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_76, [
                                  _createVNode(_component_Field, {
                                    name: `pieces[${index}].typePiece`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_component_Multiselect, _mergeProps({
                                        modelValue: _ctx.pieces[index].typePiece,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.pieces[index].typePiece) = $event),
                                        ref_for: true
                                      }, field, {
                                        options: _ctx.typeOptions,
                                        "preserve-search": true,
                                        multiple: false,
                                        searchable: true,
                                        placeholder: "Sélectionner le type de pièce",
                                        label: "label",
                                        "track-by": "value",
                                        "value-prop": "value"
                                      }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                    ]),
                                    _: 2
                                  }, 1032, ["name"]),
                                  _createVNode(_component_ErrorMessage, {
                                    name: `pieces[${index}].typePiece`,
                                    class: "text-danger"
                                  }, null, 8, ["name"])
                                ]),
                                (!_ctx.isPhotoPiece(_ctx.pieces[index].typePiece))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                      _createVNode(_component_Field, {
                                        type: "text",
                                        class: "form-control shadow-none fs-md-15 text-black",
                                        placeholder: "Entrer le numéro de la pièce",
                                        name: `pieces[${index}].numeroPiece`,
                                        modelValue: _ctx.pieces[index].numeroPiece,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.pieces[index].numeroPiece) = $event)
                                      }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_ErrorMessage, {
                                        name: `pieces[${index}].numeroPiece`,
                                        class: "text-danger"
                                      }, null, 8, ["name"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_80)),
                                _createElementVNode("div", _hoisted_81, [
                                  _createVNode(_component_Field, {
                                    type: "file",
                                    accept: "image/*",
                                    class: "form-control",
                                    onChange: ($event: any) => (_ctx.handleFileChange($event, index)),
                                    name: `pieces[${index}].urlImage`
                                  }, null, 8, ["onChange", "name"]),
                                  ((piece as any).urlImageExistante && !piece.urlImage)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                        _hoisted_83,
                                        _createElementVNode("a", {
                                          href: _ctx.getUrlApiForEtudiantsFiles((piece as any).urlImageExistante),
                                          target: "_blank",
                                          class: "text-primary small"
                                        }, "Voir", 8, _hoisted_84)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ErrorMessage, {
                                    name: `pieces[${index}].urlImage`,
                                    class: "text-danger"
                                  }, null, 8, ["name"])
                                ]),
                                (index > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                      _createElementVNode("button", {
                                        class: "btn btn-danger transition border-0 py-1 px-2",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.removeRowPiece(index))
                                      }, _hoisted_88, 8, _hoisted_86)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("button", {
                      ref: "submitButton",
                      class: "btn btn-success me-3",
                      type: "submit",
                      disabled: _ctx.isSubmitting
                    }, [
                      (!_ctx.isSubmitting)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_92))
                        : _createCommentVNode("", true),
                      (_ctx.isSubmitting)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_93))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Enregistrement...' : "Modifier l'étudiant"), 1)
                    ], 8, _hoisted_91),
                    _createVNode(_component_router_link, {
                      to: "/liste-etudiants",
                      class: "btn btn-danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Annuler ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema", "initial-values"])
        ])
      ]))
}